// plan-12 S01: phosphor decay overlay — half-res trail canvas, 480ms decay-half-time

import type { DrawPass } from '../canvas'

// decay alpha per frame at 30 FPS: 0.85^(30*0.48) ≈ 0.85^14.4 ≈ 0.10 → half-life ≈ 480ms
const TRAIL_ALPHA = 0.85
const BLEND_ALPHA = 0.18

export function createPhosphorDecay(reduced: boolean): DrawPass {
  // half-resolution offscreen canvas for performance
  let offscreen: HTMLCanvasElement | null = null
  let offCtx: CanvasRenderingContext2D | null = null
  let prevW = 0
  let prevH = 0

  return (ctx, w, h, _t): void => {
    if (reduced) return

    // initialize or resize offscreen at half resolution
    const ow = Math.ceil(w / 2)
    const oh = Math.ceil(h / 2)

    if (!offscreen || prevW !== ow || prevH !== oh) {
      offscreen = document.createElement('canvas')
      offscreen.width = ow
      offscreen.height = oh
      offCtx = offscreen.getContext('2d', { alpha: true })
      prevW = ow
      prevH = oh
    }

    if (!offCtx) return

    // draw previous frame onto offscreen at reduced alpha (creates trail)
    offCtx.globalAlpha = TRAIL_ALPHA
    offCtx.drawImage(offscreen, 0, 0, ow, oh)
    offCtx.globalAlpha = 1

    // draw current main canvas onto offscreen at half-res
    offCtx.drawImage(ctx.canvas, 0, 0, ow, oh)

    // composite the offscreen back onto main with screen blend
    ctx.globalCompositeOperation = 'screen'
    ctx.globalAlpha = BLEND_ALPHA
    ctx.drawImage(offscreen, 0, 0, ow, oh, 0, 0, w, h)
    ctx.globalAlpha = 1
    ctx.globalCompositeOperation = 'source-over'
  }
}
